import { createAction, createAsyncThunk, createReducer } from '@reduxjs/toolkit'
import axios from 'axios'

const initialState = {}

export const setContent = createAction('SET_CONTENT')

export default createReducer(initialState, builder => {
  builder.addCase(setContent, (state, action) => {
    state[action.payload.page] = action.payload.content
  })
})

export const loadContent = createAsyncThunk(
  'content/loadContent',
  async function (page, { dispatch, getState }) {
    if (getState().content[page] !== undefined) {
      return
    }

    const response = await axios.get('/api/content', {
      params: {
        page
      }
    })

    dispatch(setContent({ page, content: response.data }))
  }
)

export const loadPage = createAsyncThunk(
  'content/loadPage',
  async function (page, { dispatch, getState }) {
    if (getState().content[page] !== undefined) {
      return
    }

    const response = await axios.get('/page', {
      params: {
        page
      }
    })

    dispatch(setContent({ page, content: response.data }))
  }
)
